const { useEffect } = require('react');
const ComponentRegistry = require('hooks/useFormPrimitives/componentRegistry');
const FieldComponents = require('./fieldComponents');

// Registry construction happens inside form controllers. Resolve styled field
// modules when the hook module loads so their development checks cannot alter a
// consuming component's React hook order during its first render.
FieldComponents.preloadComponents();

module.exports = function useFormComponentRegistry(formConfig = {}) {

    useEffect(() => {

        const formId = formConfig.componentRegistry?.formId;

        ComponentRegistry.register({
            formId,
            registry: formConfig.componentRegistry
        });

        return () => {

            ComponentRegistry.unregister({
                formId
            });
        };
    }, [formConfig]);
};
